import React from 'react';
import Header from './Header';
import Hero from './Hero';
import FeaturesGrid from './FeaturesGrid';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <FeaturesGrid />
      <CTASection />
      <Footer />
    </div>
  );
};

export default LandingPage;
